 import { useMsal } from "@azure/msal-react";
import * as React from "react";
import { ComponentsHelper } from "../../core/services/ComponentHelper";
import { ILookupDictionary } from "../../lookup/types/ILookupDictionary";
import { setDataSource } from "../../redux/reducers/MembersPortalReducer";
import { FormatFields } from "../../redux/types/FormatFields";
import { IActiveAccordion } from "../../redux/types/IActiveAccordion";
import IMembersPortalComponentDataItem from "../../redux/types/IMembersPortalComponentDataItem";
import { IResultsPerPage } from "../../redux/types/IResultsPerPage";
import { ITabReduxItem } from "../../redux/types/ITabReduxItem";
import { PERMISSION_MESSAGE } from "../../repertoire/Consts";
import ITooltip from "../../repertoire/components/Tooltip/IToolTip";
import { DataSource } from "../../repertoire/types/DataSource";
import { IDraftAgreementSearchQuery } from "../types/IDraftAgreementSearchQuery";
import { IDraftAgreementSearchResult } from "../types/IDraftAgreementsSearchResult";
import { IViewAsAccessRequest } from "../types/IViewAsAccessRequest";
import DraftAgreementsSearchView from "./DraftAgreementsSearchView";
import { MembersPortalService } from "../../redux/services/MembersPortalService";
import { MembersPortalRoles } from "../../redux/types/MembersPortalRoles";
import InfoToggle from "../sharedComponents/button/InfoToggle";
import { IMembersPortalPathInfo } from "../types/IMembersPortalPathInfo";

export interface IDraftAgreementsPageProps {
    draftAgreementsPageData?: IMembersPortalComponentDataItem;
    searchViewData: IMembersPortalComponentDataItem;
    searchResultsTableData: IMembersPortalComponentDataItem;
    searchDraftAgreements?: (query: IDraftAgreementSearchQuery, lookupValues: ILookupDictionary) => void;
    draftAgreementsSearchResults: IDraftAgreementSearchResult[];
    memberAgreementSearchResults?: IDraftAgreementSearchResult[];
    loadMembersPortalFromPath: (pathInfo: IMembersPortalPathInfo, currentUserNameNumber: string, location: Location) => void;
    searchSuccessful: boolean;
    draftAgreementsMaintenanceGeneralDataViewData?: IMembersPortalComponentDataItem;
    lookupValues: ILookupDictionary;
    indexOfFirstResult?: number;
    indexOfLastResult?: number;
    resultsPerPage?: number;
    currentPage?: number;
    resetPagination: (repertoireSection: string) => void;
    updatePagination: (indexOfFirstResult: number, indexOfLastResult: number, resultsPerPage: number, currentPage: number, repertoireSection: string) => void;
    getDraftAgreementDetails: (dataSource: string, workID: number, lookupValues: ILookupDictionary, draftAgreementsMaintenanceDataViewData: IMembersPortalComponentDataItem, formats?: FormatFields[]) => void;
    addNewDraftAgreement: (lookups: ILookupDictionary, currentUserNameNumber?: string, isNew?: boolean, draftAgreementsMaintenanceGeneralDataViewData?: IMembersPortalComponentDataItem, formats?: FormatFields[]) => void;
    sortSearchResults: (name: string, results: any) => void;
    defaultActiveAccordions?: IActiveAccordion[];
    allResultsPerPage?: IResultsPerPage[];
    updateUserPreferences: (allResultsPerPage: IResultsPerPage[], activeAccordions: IActiveAccordion[], newActiveAccordionName?: string, accordionExpanded?: boolean, componentName?: string, indexOfFirstResult?: number, indexOfLastResult?: number, resultsPerPage?: number, repertoireSection?: string) => void;
    disabled?: boolean;
    roles?: string[];
    saveRoles?: (roles: string[]) => void;
    setDataSource: typeof setDataSource;
    dataSource: string;
    activeTab?: number;
    tabs?: ITabReduxItem[];
    currentUserNameNumber?: string;
    expandWorkResult?: (workResult: number) => void;
    expandedWorkResults?: number[];
    expandAllResults: () => void;
    expandAll: boolean;
    draftAgreementSearchResults?: any;
    viewAsAccessRequests?: IViewAsAccessRequest[];
    getViewAsRequests?: (userName: string) => void;
    currentUser?: string;
}

const DraftAgreementsPage: React.FC<IDraftAgreementsPageProps> = ({
    draftAgreementsPageData,
    addNewDraftAgreement,
    lookupValues,
    draftAgreementsMaintenanceGeneralDataViewData,
    currentUserNameNumber,
    searchViewData,
    searchResultsTableData,
    searchDraftAgreements,
    searchSuccessful,
    indexOfFirstResult,
    indexOfLastResult,
    loadMembersPortalFromPath,
    resultsPerPage,
    currentPage,
    resetPagination,
    updatePagination,
    sortSearchResults,
    expandAllResults,
    expandAll,
    draftAgreementSearchResults,
    getDraftAgreementDetails,
    viewAsAccessRequests,
    getViewAsRequests,
    currentUser,
    tabs,
    activeTab
}) => {
    const [loaded, setLoaded] = React.useState(false);
    const { instance, accounts } = useMsal();

    React.useEffect(() => {
        checkIfLoaded();
        getViewAsRequests(currentUser);

        const account = accounts[0]
        ComponentsHelper.createBearerHeaderFromAADLogin(instance, account);
    }, [])

    const checkIfLoaded = () => {

        if (draftAgreementsPageData.fields && draftAgreementsPageData.fields.length >= 1 && !loaded) {
            setLoaded(true);
            const header = draftAgreementsPageData.fields.find(f => f.name === "PageTitle");
            if (header) {
                document.title = header.data;
            }
        }
    }
    const addNewDraftWorks = (): void => {
        addNewDraftAgreement(lookupValues, currentUserNameNumber, true, draftAgreementsMaintenanceGeneralDataViewData);
        // SearchRequests.getConfigurationParameter(CONFIGURATION_PARAMETER_FIELD_FORMAT_KEY, WORK_MAINTENANCE_GROUP)
        //     .then(formats => {
                
        //     });
    }

    let currentDataSource = DataSource.Intray;

    const infoToggleHeaderField = draftAgreementsPageData.fields
        .find(x => x.name === 'infoToggleHeader');

    const infoToggleHtmlField = draftAgreementsPageData.fields
        .find(x => x.name === 'infoToggleHTML');


    const renderInfoToggle = (
        <InfoToggle
            headerTextItem={infoToggleHeaderField}
            htmlTextItem={infoToggleHtmlField}
            currentUserNameNumber={currentUserNameNumber}
            lookupValues={lookupValues}
            loadMembersPortalFromPath={loadMembersPortalFromPath}
        />
    )

    if (loaded) {

        const getAgreementDetails = (dataSource: string, agreementID: number) => {
            getDraftAgreementDetails(dataSource, agreementID, lookupValues, draftAgreementsMaintenanceGeneralDataViewData);
        }

        let searchPageLabelTitle = null;
        if (draftAgreementsPageData && draftAgreementsPageData.fields.length > 0) {
            searchPageLabelTitle = draftAgreementsPageData.fields.find((v, i, a) => v.name == "searchPageLabelTitle").data;
        }
        const hasPermission = MembersPortalService.hasPermissionForMenu("registerNewAgreement", MembersPortalRoles.FullAccess);
        
        let searchResults = draftAgreementSearchResults;
        return (
            <div>
                <div className="row">
                    <div className="col-md-12">
                        <span className="title">{searchPageLabelTitle}</span>
                        {hasPermission ? (
                            <div className="newWorkButton" title="Register New Agreement">
                                <div className="IconTextButton" onClick={addNewDraftWorks}>
                                    <i className="icon ms-Icon ms-Icon--CircleAddition"
                                        aria-hidden="true">
                                    </i>
                                    { draftAgreementsPageData.fields.find((v, i, a) => v.name == "registerNewAgreement")?.data || "Register New Agreement" }
                                </div>
                            </div>
                        ) : (
                            <div className="newWorkButton" title="Register New Agreement">
                                <ITooltip
                                    tooltipContent={PERMISSION_MESSAGE}
                                    showTooltip={true}
                                    placement="top"
                                >
                                    <span style={{ display: 'inline-block' }}>
                                        <div className="IconTextButton disabled">
                                            <i className="icon ms-Icon ms-Icon--CircleAddition disabled"
                                                aria-hidden="true">
                                            </i>
                                            { draftAgreementsPageData.fields.find((v, i, a) => v.name == "registerNewAgreement")?.data || "Register New Agreement" }
                                        </div>
                                    </span>
                                </ITooltip>
                            </div>
                        )}
                    </div>
                </div>
                {renderInfoToggle }
                <DraftAgreementsSearchView
                    searchViewData={searchViewData}
                    searchResultsTableData={searchResultsTableData}
                    lookupValues={lookupValues}
                    searchDraftAgreements={searchDraftAgreements}
                    draftAgreementsSearchResults={searchResults}
                    searchSuccessful={searchSuccessful}
                    indexOfFirstResult={indexOfFirstResult}
                    indexOfLastResult={indexOfLastResult}
                    resultsPerPage={resultsPerPage}
                    currentPage={currentPage}
                    resetPagination={resetPagination}
                    updatePagination={updatePagination}
                    sortSearchResults={sortSearchResults}
                    expandAllResults={expandAllResults}
                    expandAll={expandAll}
                    currentUserNameNumber={currentUserNameNumber}
                    getAgreementDetails={getAgreementDetails}
                    dataSource={currentDataSource}
                    tabs={tabs}
                    activeTab={activeTab}
                />
            </div>
        );
    }
    return <div>Loading ...</div>
}

export default DraftAgreementsPage;
